export const lineTrendOptions = {
    responsive: true,
    maintainAspectRatio: false,
    datasets: {
        line: {
            pointRadius: 8,
            pointHoverRadius: 8,
            borderWidth: 3,
            borderJoinStyle: "round",
            borderColor: "#7BA7CC",
            pointBackgroundColor: "white",
        },
    },
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            enabled: false,
        },
        datalabels: {
            color: "#142533",
            font: {
                size: 14,
                weight: "bold",
            },
            labels: {
                index: {
                    align: "end",
                    anchor: "center",
                },
            },
        },
    },
    scales: {
        y: {
            ticks: {
                display: false,
            },
            grid: {
                display: false,
            },
            border: {
                display: false,
            },
            beginAtZero: true,
            offset: true,
        },
        x: {
            grid: {
                display: false,
            },
            border: {
                display: false,
            },
            ticks: {
                maxRotation: 90,
            },
        },
    },

    interaction: {
        mode: "index",
    },
};

const getOrCreateLegendList = (chart, id) => {
    const legendContainer = document.getElementById(id);
    let listContainer = legendContainer.querySelector("ul");
    let listContainer2 = legendContainer.querySelector("ul:last-child");

    if (!listContainer) {
        listContainer = document.createElement("ul");
        listContainer.className = "vstack p-0 gap-1 fs-7 fs-8-xs justify-content-center m-0";

        listContainer2 = listContainer.cloneNode();

        legendContainer.appendChild(listContainer);
        legendContainer.appendChild(listContainer2);
    }

    return [listContainer, listContainer2];
};

export const htmlLegendPlugin = {
    id: "htmlLegend",
    afterUpdate(chart, args, options) {
        const [ul, ul2] = getOrCreateLegendList(chart, options.containerID);

        // Remove old legend items
        while (ul.firstChild) {
            ul.firstChild.remove();
        }
        while (ul2.firstChild) {
            ul2.firstChild.remove();
        }

        // Reuse the built-in legendItems generator
        const items = chart.options.plugins.legend.labels.generateLabels(chart);
        items.push({
            fontColor: "#666",
            datasetIndex: 0,
            lineWidth: 2,
            strokeStyle: "#fff",
            text: "Time Frame",
            type: "dataset",
        });
        items.push({
            fontColor: "#666",
            datasetIndex: 1,
            lineWidth: 2,
            strokeStyle: "#fff",
            text: "Average",
            type: "dataset",
        });

        items.forEach(item => {
            const li = document.createElement("li");
            li.className = "hstack align-items-center gap-1";
            li.style.cursor = "pointer";

            li.onclick = () => {
                if (item.type === "dataset") {
                    chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                } else {
                    chart.toggleDataVisibility(item.index);
                }
                chart.update();
            };

            let box = null;
            if (item.type === "dataset") {
                // Icon Box
                const boxSpan = document.createElement("span");
                boxSpan.style.position = "relative";
                boxSpan.style.width = "20px";
                boxSpan.style.height = "20px";
                boxSpan.style.minWidth = "20px";
                const outCircle = document.createElement("span");
                const inCircle = document.createElement("span");
                outCircle.className = "half-circle-doughnut-legend";
                if (item.datasetIndex === 0) {
                    outCircle.style.borderColor = "var(--ra-yellow)";
                } else if (item.datasetIndex === 1) {
                    inCircle.style.borderColor = "var(--ra-yellow)";
                }
                inCircle.className = "half-circle-doughnut-legend in";
                boxSpan.appendChild(outCircle);
                boxSpan.appendChild(inCircle);
                box = boxSpan;
            } else {
                // Color box
                const boxSpan = document.createElement("span");
                boxSpan.style.background = item.fillStyle;
                boxSpan.style.borderColor = item.strokeStyle;
                boxSpan.style.borderWidth = item.lineWidth + "px";
                boxSpan.style.display = "inline-block";
                boxSpan.style.flexShrink = 0;
                boxSpan.style.height = "20px";
                boxSpan.style.width = "20px";
                box = boxSpan;
            }

            // Text
            const textContainer = document.createElement("span");
            textContainer.className = "m-0 p-0";
            textContainer.style.color = item.fontColor;
            textContainer.style.textDecoration = item.hidden || (item.type === "dataset" && !chart.isDatasetVisible(item.datasetIndex)) ? "line-through" : "";

            const text = document.createTextNode(item.text);
            textContainer.appendChild(text);

            li.appendChild(box);
            li.appendChild(textContainer);
            if (item.type === "dataset") {
                ul.appendChild(li);
            } else {
                ul2.appendChild(li);
            }
        });
    },
};
export const doughnutOptions = legendContainerId => {
    return {
        responsive: true,
        maintainAspectRatio: true,
        layout: {
            padding: 25,
        },
        plugins: {
            htmlLegend: {
                containerID: legendContainerId,
            },
            legend: {
                display: false,
            },
            tooltip: {
                displayColors: false,
                callbacks: {
                    label: function (item) {
                        return `${item.dataset.label}: ${item.raw.toFixed(2).toLocaleString()}%`;
                    },
                },
            },
            datalabels: {
                backgroundColor: function (context) {
                    return context.dataset.backgroundColor;
                },
                borderColor: "white",
                borderRadius: 5,
                borderWidth: 2,
                color: "white",
                font: {
                    weight: "bold",
                    size: 10,
                },
                padding: 4,
                formatter: function (value) {
                    return typeof value === "number" ? value.toFixed(2).toLocaleString() + "%" : null;
                },
            },
        },
        interaction: {
            mode: "index",
        },
    };
};

export const pieOption = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
        legend: {
            display: true,
            labels: {
                usePointStyle: true,
            },
        },
        tooltip: {
            displayColors: false,
            callbacks: {
                label: function (item) {
                    const labelIndex = item.dataIndex; // Get the index of the data point
                    const label = item.chart.data.labels[labelIndex]; // Get the label based on the index
                    return `${label}: ${item.raw.toLocaleString()}%`;
                },
            },
        },
        datalabels: {
            backgroundColor: function (context) {
                return context.dataset.backgroundColor;
            },
            color: "white",
            font: {
                weight: "bold",
                size: 12,
            },
            padding: 4,
            formatter: function (value) {
                return typeof value === "number" ? value.toLocaleString() + "%" : null;
            },
        },
    },
    interaction: {
        mode: "index",
    },
};

export const barOption = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            displayColors: false,
            callbacks: {
                label: function (item) {
                    const labelIndex = item.dataIndex;
                    const label = item.chart.data.labels[labelIndex];
                    return `${label}: ${item.raw.toLocaleString()}`;
                },
            },
        },
        datalabels: {
            color: "black",
            font: {
                weight: "bold",
                size: context => {
                    if (window.innerWidth < 500) {
                        return 8; // Mobile devices
                    } else if (window.innerWidth < 768) {
                        return 12; // Tablets
                    } else {
                        return 14; // Desktops
                    }
                },
            },
            padding: 4,
            formatter: function (value) {
                return typeof value === "number" ? value.toFixed(0).toLocaleString() : null;
            },
        },
    },
    scales: {
        y: {
            ticks: { display: false },
            grid: { display: false },
            border: { display: false },
            beg55inAtZero: true,
        },
        x: {
            stacked: false,
            ticks: {
                autoSkip: false,
                maxRotation: 0,
                font: {
                    size: context => {
                        if (window.innerWidth < 500) {
                            return 8; // Mobile devices
                        } else if (window.innerWidth < 768) {
                            return 10; // Tablets
                        } else {
                            return 12; // Desktops
                        }
                    },
                },
                callback: function (value) {
                    let maxLabelLength;
                    if (window.innerWidth < 500) {
                        maxLabelLength = 8; // Mobile devices
                    } else if (window.innerWidth < 768) {
                        maxLabelLength = 14; // Tablets
                    } else {
                        maxLabelLength = 20; // Desktops
                    }
                    const label = this.getLabelForValue(value);
                    if (label.length > maxLabelLength) {
                        const words = label.split(" ");
                        const midIndex = Math.ceil(words.length / 2);
                        return [words.slice(0, midIndex).join(" "), words.slice(midIndex).join(" ")];
                    }
                    return label;
                },
            },
            grid: {
                display: false,
            },
        },
    },
    interaction: {
        mode: "index",
    },
};

export const backgroundPlugin = {
    id: "customCanvasBackgroundColor",
    beforeDraw: (chart, args, options) => {
        const { ctx } = chart;
        ctx.save();
        ctx.globalCompositeOperation = "destination-over";
        ctx.fillStyle = options.color || "#99ffff";
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
    },
};
